import React from 'react';
import Moment from 'react-moment';

const LatestNews = props => (
  <div style={{ backgroundColor: '#eee' }}>
    <div className="padding-top-large" />
    <div className="business-blog-1x">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="business-title-middle">
              <h2>Derniers Articles sur DC6</h2>
              <span className="title-border-middle" />
            </div>
          </div>
          <div className="col-md-12">
            <div className="margin-top-middle" />
          </div>
          {props.articles.slice(0, 4).map(article => (
            <div className="col-md-3" key={article._id}>
              <div className="single-bolg hover01">
                <a href={`https://www.digitalcongo.net/article/${article._id}`} target="_blank">
                  <figure>
                    <img src={article.image_M} alt={article.title} className="" />
                  </figure>
                </a>
                <div className="blog-content">
                  <a href={`https://www.digitalcongo.net/article/${article._id}`} target="_blank">
                    {article.title}
                  </a>
                  <span>
                    <i className="fa fa-clock-o">
                      {' '}
                      <Moment format="DD/MM/YYYY">{article.date_created}</Moment>
                    </i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    <div className="padding-top-large" />
  </div>
);
export default LatestNews;



// WEBPACK FOOTER //
// ./src/components/LatestNewsFR.js